import React, { useEffect, useState } from "react";
import * as styles from "./PermissionSidePanel.module.scss";
import { Panel } from "cprime-foundational-components";
import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";
import { triggerToast } from "../../utils/toast";
import {
  createPermission,
  editPermission,
  resetPermissionData,
} from "../../store/slices/PermissionSlice/permissionSlice";
import { useParams } from "react-router-dom";

import Button from "../Common/CprimeButton";
interface PermissionSidePanelProps {
  onClose: () => void;
  BodyComponent: React.ReactNode;
  isEdit: boolean;
  permission_id?: number;
  isAvailable: boolean;
  setPermissionUpdate?: any;
  permission?: any;
  getPermission?: any;
  getApplicationDetails?: () => void;
}

const PermissionSidePanel: React.FC<PermissionSidePanelProps> = ({
  onClose,
  BodyComponent,
  isEdit,
  permission_id,
  isAvailable = false,
  setPermissionUpdate,
  permission,
  getPermission,
  getApplicationDetails,
}) => {
  const scssClass = styles as any;
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const permissionFormData = useSelector(
    (state: RootState) => state?.permission?.form,
  );

  const isFormValid = () => {
    if (!permissionFormData) return false;
    const { specifyPermissionType, description } = permissionFormData;
    return (
      specifyPermissionType &&
      specifyPermissionType.trim() &&
      description &&
      description?.trim()
    );
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const applicationId = id?.split("-")?.[1];
      if (applicationId) {
        let result;
        if (isEdit && permission_id) {
          result = await editPermission(
            permissionFormData,
            `/perms/edit`,
            applicationId,
          );
        } else {
          result = await createPermission(
            permissionFormData,
            "/perms/add",
            applicationId,
          );
        }

        if (result?.status === "SUCCESS") {
          triggerToast(result?.message, "success");
          if (getPermission) getPermission();
          if (getApplicationDetails) getApplicationDetails();
          dispatch(resetPermissionData());
          onClose();
        } else {
          triggerToast(result?.message || result?.error, "error");
        }
      }
    } catch (err: any) {
      triggerToast(
        err?.response?.data?.message ??
          (isEdit
            ? `Failed to Update Permission ${permission_id}. Please try again.`
            : `Failed to Create Permission. Please try again.`),
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Panel
        id="PermissionSidePanel"
        className={scssClass.userGroupMainPanel}
        sx={{
          "& .MuiDrawer-root": { padding: "0px" },
          "& .MuiPaper-root": {
            // width: "800px",
            top: "104px",
            height: "calc(100vh - 104px)",
            gap: "24px",
          },
        }}
        open={true}
        title={isEdit ? "Edit Permisison" : "Add Permission"}
        side="right"
        onClose={onClose}
        body={
          <>
            {BodyComponent}
            <Stack
              direction="row"
              justifyContent="space-between"
              // p="1rem 1.5rem 0rem 0rem"
              className={scssClass.footerButtons}
            >
              {isEdit ? (
                <Button
                  variant="danger"
                  size="medium"
                  onClick={() => {
                    if (setPermissionUpdate) {
                      setPermissionUpdate(permission, !isAvailable, onClose);
                    }
                  }}
                  sx={{
                    ".MuiTypography-body1": {
                      p: {
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "ToyotaType-Regular",
                      },
                    },
                  }}
                >
                  Make {isAvailable ? "Unavailable" : "Available"}
                </Button>
              ) : (
                <span></span>
              )}
              <Stack direction="row" gap={2}>
                <Button
                  variant="tertiary"
                  sx={{
                    ".MuiTypography-body1": {
                      p: {
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "ToyotaType-Regular",
                      },
                    },
                  }}
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disabled={!isFormValid()}
                  onClick={handleSave}
                  sx={{
                    ".MuiTypography-body1": {
                      p: {
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "ToyotaType-Regular",
                      },
                    },
                  }}
                  loading={isLoading}
                >
                  Save Permission
                </Button>
              </Stack>
            </Stack>
          </>
        }
        // body={BodyComponent}
      />
      <span
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          width: "100vw",
          height: "calc(100vh - 104px)",
          zIndex: 1100,
          top: "104px",
          left: 0,
        }}
      ></span>
    </>
  );
};

export default PermissionSidePanel;
